const MercatorProjection = (function() {
  var TILE_SIZE = 256;

  // 0.0 .. 1.0の座標に変換
  function latitudeToY(latitude) {
    var sinLatitude = Math.sin(latitude * (Math.PI / 180));
    return 0.5 - Math.log((1 + sinLatitude) / (1 - sinLatitude)) / (4 * Math.PI);
  }

  // その逆
  function yToLatitude(y) {
    return 90 - 360 * Math.atan(Math.exp((y - 0.5) * (2 * Math.PI))) / Math.PI;
  }

  // 0.0 .. 1.0の座標に変換
  function longitudeToX(longitude) {
    return (longitude + 180.0) / 360.0;
  }

  // その逆
  function xToLongitude(x) {
    return 360.0 * (x - 0.5);
  }

  return {
    getPixelDefferencePosition: function(lat, lng, z, pixelx, pixely) {
      lat = parseFloat(lat);
      lng = parseFloat(lng);
      pixelx = parseInt(pixelx);
      pixely = parseInt(pixely);

      var scale = Math.pow(2, parseInt(z));

      // xy per pixel
      var pp = 1 / scale / TILE_SIZE;

      var translatey = latitudeToY(lat) + pp * pixely;
      var translatex = longitudeToX(lng) + pp * pixelx;

      var translateLat = yToLatitude(translatey);
      var translateLng = xToLongitude(translatex);

      return {lat: translateLat, lon: translateLng};
    },
    getPositionDifferencePixel: function(lat1, lng1, lat2, lng2, z){
      lat1 = parseFloat(lat1);
      lng1 = parseFloat(lng1);
      lat2 = parseFloat(lat2);
      lng2 = parseFloat(lng2);

      var scale = Math.pow(2, parseInt(z));

      var y1 = latitudeToY(lat1);
      var x1 = longitudeToX(lng1);
      var y2 = latitudeToY(lat2);
      var x2 = longitudeToX(lng2);

      var say = y2 - y1;
      var sax = x2 - x1;

      // xy per pixel
      var pp = 1 / scale / TILE_SIZE;

      var pixely = Math.ceil(say / pp);
      var pixelx = Math.ceil(sax / pp);

      return {y: pixely, x: pixelx};
    }
  };
})();

export default MercatorProjection;